import React from "react";
import styles from './BasicObjectsSelector.module.css'


export default class BasicObjectsSelector extends React.PureComponent {
	constructor( props ) {
		super(props);
		this.textContainer = React.createRef();
		this.circleContainer = React.createRef();
		this.rectangleContainer = React.createRef();
		this.lineContianer = React.createRef();
		this.getGraph = this.getGraph.bind(this);
	}

	componentDidMount() {
		this.setupDraggableArea();
	}

    componentWillUnmount() {
        if (this.dragSources) {
            this.dragSources.forEach(dragSource => {
                dragSource.removeListeners()
            })
        }
    }

    getGraph = () => this.props.graph;

    setupDraggableArea = () => {
        const {mxUtils} = window;
        this.textDragSource = mxUtils.makeDraggable(this.textContainer.current, this.getGraph, this.place_text, null, 0, 0);
        this.circleDragSource = mxUtils.makeDraggable(this.circleContainer.current, this.getGraph, this.place_circle, null, 0, 0);
        this.rectangleDragSource = mxUtils.makeDraggable(this.rectangleContainer.current, this.getGraph, this.place_rectangle, null, 0, 0);
        this.lineDragSource = mxUtils.makeDraggable(this.lineContianer.current, this.getGraph, this.place_line, null, 0, 0);
        this.dragSources = new Array(this.textDragSource, this.circleDragSource, this.rectangleDragSource, this.lineDragSource);
    };

    isFigureWithinBackgroundBounds = (graph, pt, width, height) => {
        /**
         * Prevent drop if figure set out of background bounds
         */
        let graphAbsoluteCoordinates = graph.view.relativeCoordsToAbsolute(
            {x: pt.x * graph.view.scale, y: pt.y * graph.view.scale}
        );

        if (!graph.view.isFigureWithinBackgroundBounds({
            x: graphAbsoluteCoordinates.x,
            y: graphAbsoluteCoordinates.y,
            width: width * graph.view.scale,
            height: height * graph.view.scale
        })) {
            return false
        }
        return true
        /******************************************************/
    }

    place_line = (graph, evt, cell, x, y) => {
        let pt = graph.getPointForEvent(evt);
        const parent = graph.getDefaultParent();

        const isFigureWithinBackgroundBound = this.isFigureWithinBackgroundBounds(graph, pt, 100, 100);
        if (!isFigureWithinBackgroundBound) return;
        /******************************************************/

        graph.getModel().beginUpdate();
        try {
            const geometry = new window.mxGeometry(100, 100, 100, 100);
            const line = new window.CYNYLine('', geometry, 'shape=connector;startArrow=none;endArrow=none;html=1;rounded=0;edgeStyle="";strokeColor=#000000');
            line.geometry.setTerminalPoint(new window.mxPoint(pt.x + 50, pt.y), true);
            line.geometry.setTerminalPoint(new window.mxPoint(pt.x, pt.y + 50), false);
            graph.addCell(line, parent);
        } finally {
            graph.getModel().endUpdate();
        }
    }
    place_rectangle = (graph, evt, cell, x, y) => {
        let pt = graph.getPointForEvent(evt);
        const parent = graph.getDefaultParent();

        const isFigureWithinBackgroundBound = this.isFigureWithinBackgroundBounds(graph, pt, 80, 40);
        if (!isFigureWithinBackgroundBound) return
        /******************************************************/

        graph.getModel().beginUpdate();
        try {
            const geometry = new window.mxGeometry(pt.x, pt.y, 80, 40);
            const rectangle = new window.CYNYRectangle('', geometry, 'shape=rectangle;fillColor=transparent;');
            graph.addCell(rectangle, parent);
        } finally {
            graph.getModel().endUpdate();
        }
    }

    place_circle = (graph, evt, cell, x, y) => {
        let pt = graph.getPointForEvent(evt);
        const parent = graph.getDefaultParent();

        const isFigureWithinBackgroundBound = this.isFigureWithinBackgroundBounds(graph, pt, 40, 40);
        if (!isFigureWithinBackgroundBound) return
        /******************************************************/

        graph.getModel().beginUpdate();
        try {
            const geometry = new window.mxGeometry(pt.x, pt.y, 40, 40);
            const circle = new window.CYNYCircle('', geometry, 'shape=ellipse;fillColor=transparent;');
            graph.addCell(circle, parent);
        } finally {
            graph.getModel().endUpdate();
        }
    }
    place_text = (graph, evt, cell, x, y) => {
        let pt = graph.getPointForEvent(evt);
        let parent = graph.getDefaultParent();


        const isFigureWithinBackgroundBound = this.isFigureWithinBackgroundBounds(graph, pt, 40, 20);
        if (!isFigureWithinBackgroundBound) return;
        /******************************************************/

        graph.getModel().beginUpdate();
        try {
            const geometry = new window.mxGeometry(pt.x, pt.y, 40, 20);
            const textCell = new window.CYNYText('Text', geometry, 'shape=text;fillColor=transparent;strokeColor=transparent;');
            textCell.textCell = true;
            graph.addCell(textCell, parent)
        } finally {
            graph.getModel().endUpdate();
        }
    };

    render() {
        return (
            <>
                <div className={styles.symbols_container}>
                    <a ref={this.lineContianer} href="#" className={styles.draw_icon} title="ADD LINE"
                       id="line_add_icon">
                        <svg className={styles.svgFigure}>
                            <g transform="translate(0.5,0.5)">
                                <path d="M 4 66 L 66 4" fill="none" stroke="white" strokeMiterlimit="10"
                                      pointerEvents="stroke" visibility="hidden" strokeWidth="9"/>
                                <path d="M 4 66 L 66 4" fill="none" stroke="#000000" strokeMiterlimit="10"
                                      strokeWidth="2"/>
                            </g>
                        </svg>
                    </a>
                    <a ref={this.rectangleContainer} href="#" className={styles.draw_icon}
                       title="ADD RECTANGLE">
                        <svg className={styles.svgFigure}>
                            <g transform="translate(0.5,0.5)">
                                <rect x="4" y="20" width="64" height="32" fill="#ffffff" stroke="#000000"
                                      strokeWidth="2"
                                      pointerEvents="all"/>
                            </g>
                        </svg>
                    </a>
                    <a ref={this.circleContainer} href="#" className={styles.draw_icon} title="ADD CIRCLE">
                        <svg className={styles.svgFigure}>
                            <g transform="translate(0.5,0.5)">
                                <ellipse cx="36" cy="36" rx="31.200000000000001" ry="31.200000000000001"
                                         fill="#ffffff"
                                         stroke="#000000" strokeWidth="2" pointerEvents="all"/>
                            </g>
                        </svg>
                    </a>
                    <a ref={this.textContainer} href="#"
                       style={{textDecoration: "none"}}
                       className={`${styles.draw_icon} ${styles.draw_icon_text}`}
                       title="ADD TEXT">
                        <span>A</span>
                    </a>
                </div>
            </>
        )
    }
}
